import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { getTiposIndicadorByField } from 'entity/TipoIndicador/all'
import { getIndicadorByField } from 'entity/Indicador/all'
import { Typography } from '@mui/material'
import GraficosPainel from './GraficosPainel'
import GraficosExtraPainel from './GraficosExtraPainel'

function CardIndicadorProps({ indicadorProps }) {
    const { mediaAgrupadorList, IndicadorClass, agrupador, paramsCliente } = indicadorProps
    let meta = paramsCliente ? paramsCliente.meta : null;
    let nomeAgrupador = agrupador ? agrupador.nome : "Período"
    let fullName = IndicadorClass.constructor.fullName
    let field = IndicadorClass.constructor.field

    if (IndicadorClass.multTipo) {
        field = (IndicadorClass.constructor.field + IndicadorClass.type.field).toLowerCase()
    }

    return (
        <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", borderradius: 5, padding: 10, margin: 10, flex: "1 1 400px", display: "flex", flexDirection: "column", alignItems: "center", width: 300, maxWidth: 500 }}>
            {/* obtendo grafico */}
            {/* {new IndicadorClass().constructor.getGraficoPainel(mediaAgrupadorList, fullName, nomeAgrupador, meta)} */}
            <GraficosPainel mediaAgrupadorList={mediaAgrupadorList} fullName={fullName} nomeAgrupador={nomeAgrupador} meta={meta} field={field} />

            {/* obtendo graficos secundário */}
            {/* {IndicadorClass.constructor.getGraficoExtraPainel(indicadorProps, nomeAgrupador)} */}
            <GraficosExtraPainel indicadorProps={indicadorProps} nomeAgrupador={nomeAgrupador} field={field} />
        </div>
    )
}

export default function GraficosIndicadores({ apontamentosPorTipo }) {
    const [listIndicadorPros, setListIndicadorPros] = useState([])

    useEffect(() => {
        if (apontamentosPorTipo) {
            let list = []
            for (const fTipoClass of Object.keys(apontamentosPorTipo)) {
                const TipoClass = getTiposIndicadorByField(fTipoClass)

                for (const fIndicadorClass of Object.keys(apontamentosPorTipo[fTipoClass])) { // percorrendo os indicadores dentro do tipo de indicador -> colheitas: [ piso: {...}, perdas {...}, ... ]
                    const IndicadorClass = getIndicadorByField(fIndicadorClass)
                    let apontamentosProps = _.get(apontamentosPorTipo, `${TipoClass.field}.${IndicadorClass.field}`) // ex: colheitas.piso
                    list.push(apontamentosProps)
                }
            }
            setListIndicadorPros(list)
        } else {
            setListIndicadorPros([])
        }
    }, [apontamentosPorTipo])

    return (
        <div>
            {(!listIndicadorPros.length || !listIndicadorPros.filter(x => x.apontamentos.length > 0).length) &&
                <Typography>Sem dados para os gráficos</Typography>
            }
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                {listIndicadorPros.filter(x => x.apontamentos.length > 0).map((v, i) => <CardIndicadorProps key={i} indicadorProps={v} />)}
            </div>
        </div>
    )
}
